import React, {Component} from 'react'
import {connect} from 'react-redux'
import Resources from '../../../data/services/resources'
import AssetsTab from './assetsTab'
import Page from "../../../common/components/layout/layout-components/page";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import NavResponsive from "../../../common/components/nav-responsive";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import Layout from "../../../common/components/layout";
import DepreciationTab from "./depreciation";

class AssetsInventoryPageView extends Component {
    constructor(props) {
        super(props)

        const tabs = [
            {
                name: 'Assets',
                resource: Resources.AssetsAssets,
                current: true,
                visible: true
            }
            ,{
                name: 'Depreciation',
                resource: Resources.JournalPending,
                current: false,
                visible: true
            }
        ]

        this.state = {
            tabs: tabs,
            selectedTab: Resources.AssetsAssets,
            breakpoint: {}
        }
    }

    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }

        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }

    handleBreakpointChange = (breakpoint) => {
        this.setState({
            breakpoint
        })
    }

    render() {
        const {translate, resource} = this.props

        return (
            <Layout
                onBreakpointChange={this.handleBreakpointChange}
                isAccessible={!(resource.errorStatus === 2)}
                {...this.props}
            >
                <Page>
                    <PageHeader
                        title={translate('tab.assets')}
                        afterTitle={(
                            <PageHeaderInfo
                                dispatch={this.props.dispatch}
                            />
                        )}
                    />

                    <div className="hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div className="sm:hidden">
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    {this.state.selectedTab === Resources.AssetsAssets && (
                        <AssetsTab
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.JournalPending && (
                        <DepreciationTab
                            translate={translate}
                            breakpoint={this.state.breakpoint}
                        />
                    )}

                </Page>
            </Layout>
        )
    }
}

export default connect(state => state)(AssetsInventoryPageView)
